<template>
    <v-dialog-old ref="dialog" id="paymentDataRejectDialog">
        <form>
            <fieldset width="600">
                <legend>Причина отклонения</legend>
                <form>
                    <label>
                        <input type="radio" v-model="rejectReasonDefault" value="Данные по вашему ФИО/ИНН не найдены в реестре самозанятых">
                        <span>Данные по вашему ФИО/ИНН не найдены в реестре самозанятых</span>
                    </label>
                    <label>
                        <input type="radio" v-model="rejectReasonDefault" value="Введённые данные не соответствуют паспорту">
                        <span>Введённые данные не соответствуют паспорту</span>
                    </label>
                    <label>
                        <input type="radio" v-model="rejectReasonDefault" value="Приложите, пожалуйста, справку о постановке на учет в качестве самозанятого (КНД 1122035)">
                        <span>Приложите, пожалуйста, справку о постановке на учет в качестве самозанятого (КНД 1122035)</span>
                    </label>
                    <label>
                        <input type="radio" v-model="rejectReasonDefault" value="Другое">
                        <span>Другая причина</span>
                    </label>
                    <textarea v-model="rejectReason" :disabled="rejectReasonDefault !== 'Другое'"/>
                </form>
            </fieldset>
            <footer>
                <v-loading-component @click="submit">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['green', loadingClass]" :disabled="!rejectReasonDefault">Отказать</button>
                    </template>
                </v-loading-component>
            </footer>
        </form>
    </v-dialog-old>
</template>

<script>
export default {
    data: function () {
        return {
            rejectReasonDefault: '',
            rejectReason: '',
            doctorPaymentDataId: null,
        };
    },
    methods: {
        resetData() {
            this.rejectReasonDefault = '';
            this.rejectReason = '';
        },
        show(doctorPaymentDataId) {
            this.resetData();

            this.doctorPaymentDataId = doctorPaymentDataId;

            this.$refs.dialog.show();
        },
        submit(btn) {
            if (!this.rejectReasonDefault) {
                return;
            }
            btn.startLoadingAnimation();

            this.axios.post('doctorPaymentData/reject/' + this.doctorPaymentDataId, {
                rejectReason: this.rejectReasonDefault === 'Другое' ? this.rejectReason : this.rejectReasonDefault
            }).then(response => {
                btn.stopLoadingAnimation();

                this.$emit('rejected');

                this.$refs.dialog.hide();
            }).catch(() => btn.stopLoadingAnimation());
        }
    },
}
</script>

<style>
#paymentDataRejectDialog {
    width: 705px;
}
</style>
